import { useQuery } from "@tanstack/react-query";
import {
	getCurrentCampaign,
	getFutureCampaigns,
} from "../repositories/NextCampaignsRepository";

const POLLING_INTERVAL = 30_000;

export const useCurrentCampaign = () => {
	return useQuery({
		queryKey: ["nextCampaigns", "current"],
		queryFn: ({ signal }) => getCurrentCampaign({ signal }),
		refetchInterval: POLLING_INTERVAL,
	});
};

export const useFutureCampaigns = () => {
	return useQuery({
		queryKey: ["nextCampaigns", "future"],
		queryFn: ({ signal }) => getFutureCampaigns({ signal }),
		refetchInterval: POLLING_INTERVAL,
	});
};
